export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-6-eb798b734d3a8851533b7331ca192a42.jpg";